<template>
    <div class="collegePlan">
        <div class="title">
            <div class="text">RISC-V主题竞赛</div>
            <div class="blueLine"></div>
        </div>
        <div class="banner">
            <div class="bannerItem" @click="gotoInnovate" style="cursor:pointer">
                <img style="z-index:2" src="@/assets/image/college/banner1.png" alt="">
                <div class="content">
                    <div class="theme">第二届RISC-V MCU <br/> 创新应用大赛</div>
                    <div class="detailLink" >了解详情>>></div>
                </div>
            </div>
            <div class="bannerItem" @click="gotoChip" style="cursor:pointer">
                <img style="z-index:2" src="@/assets/image/college/banner4.png" alt="">
                 <div class="content">
                     <div class="theme">全国大学生嵌入式芯片 <br/> 与系统设计竞赛</div>
                     <div class="detailLink" >了解详情>>></div>
                 </div>
            </div>
            <!-- <div class="bannerItem" @click="gotoCar" style="cursor:pointer">
                <img style="z-index:2" src="@/assets/image/college/banner2.png" alt="">
                 <div class="content">
                     <div class="theme">全国大学生 <br/> 智能汽车竞赛</div>
                     <div class="detailLink" >了解详情>>></div>
                 </div>
            </div> -->
            <!-- <div class="button">
                <img style="cursor:pointer" src="@/assets/image/college/button_left.png" alt="">
                <img style="cursor:pointer" src="@/assets/image/college/button_right.png" alt="">
            </div> -->
        </div>
        <div class="book">
            <div class="bookContent">
                <div class="bookTitle">教材及课程</div>
                <div class="mainContent">
                    <el-carousel class="carousel" trigger="click" style="height:480px; width:100%;">
                        <el-carousel-item v-for="(item,index) in bookArr" :key="index">
                            <div class="bookItem">
                                <div class="leftText">
                                    <div class="leftTitle" v-html="item.bookTitle"></div>
                                    <div class="leftSection">{{item.bookBrief}}</div>
                                </div>
                                <div class="rightImg" style="margin-right:130px">
                                    <img :src="item.imgUrl" alt="">
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
        <div class="labor">
            <div class="laborBg">
                <img src="@/assets/image/college/labor_bg.png" alt="">
            </div>
            <div class="laborTitle">
                <div class="titleText"> 联合实验室 </div>
                <div class="blueLine"></div>
            </div>
            <div class="laborContent">
                <div class="laborLeft">
                    <img src="@/assets/image/college/labor.png" alt="">
                    <p>我们期待搭建产业界与学术界的桥梁，培养RISC-V人才</p>
                </div>
                <div class="laborRight">
                    <!-- <img class="borderBg" src="@/assets/image/college/sz_border.png" alt=""> -->
                    <div class="dnImg" @click="gotoDN" @mouseenter='enterDN' @mouseleave='leaveDN'>
                        <img id="DN_license" style="width:100%" src="@/assets/image/college/dn.png" alt="">
                        <div class="dn_text">东南大学</div>
                    </div>
                    <div class="szImg" @click="gotoSZ" @mouseenter='enterSZ' @mouseleave='leaveSZ'>
                        <img id="SZ_license" src="@/assets/image/college/sz.png" alt="">
                        <div class="sz_text">苏州大学</div>
                    </div>
                    <div class="hfImg" @click="gotoHF" @mouseenter='enterHF' @mouseleave='leaveHF'>
                        <img id="HF_license" src="@/assets/image/college/hf.png" alt="">
                        <div class="hf_text">合肥工业大学</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="contact">
            <div class="header">
                <img src="@/assets/image/college/contact_header.png" alt="">
            </div>
            <div class="cotactWay">
                <div class="wayText">合作联系方式</div>
                <div class="contactEmail">
                    <img src="@/assets/image/college/contact_email.png" alt="">
                </div>
                <div class="contactPhone">
                    <img src="@/assets/image/college/contact_phone.png" alt="">
                </div>
            </div>

        </div>
        <div class="position">
            <div class="positionItem"  @click="gotoPositon1">
                <img src="@/assets/image/college/position1.png" alt="">
                <div class="text" style="margin-left: 48px;">RISC-V国际基金会战略会员</div>
            </div>
            <div style="display:flex;">
                <div class="positionItem"  @click="gotoPositon2">
                    <img style="margin-right:15px" src="@/assets/image/college/position2.png" alt="">
                    <div class="text">中国开放指令生态（RISC-V）联盟成员</div>
                </div>
                <div class="positionItem" style="margin-left:40px" @click="gotoPositon3">
                    <div class="text">中国RISC-V产业联盟成员</div>
                </div>
            </div>
            
        </div>

    </div>
</template>
<script>
import { getAction, postAction } from '@/request/http'//引入封装的get post方法
export default {
    components: {
    },
    data(){
        return{
            positionArr:[
                { src: require('@/assets/image/college/position1.png') , text:'RISC-V基金会战略会员', link:'https://riscv.org'},
                { src: require('@/assets/image/college/position2.png') , text:'中国开放指令生态（RISC-V）联盟成员', link:'http://crva.ict.ac.cn'}
            ],
            bookArr:[
                {
                    bookTitle:'RISC-V架构嵌入式原理及应用',
                    bookBrief:'以RISC-V架构单片机CH32V103的基本结构和原理为主线，将单片机开发项目实战的思想和方法贯穿全书，讲述RISC-V基础知识，介绍CH32V103的外设模块，并给出综合应用设计案例。读者可按照书中的有关内容完成案例的自主开发，提高实践能力。',
                    imgUrl:require('@/assets/image/college/bookImg.png'),
                },
                {
                    bookTitle:'RISC-V嵌入式开发实践<br/> —— 基于CH32V307微控制器',
                    bookBrief:'本书内容是在作者前期撰写的普通高等教育“十一五”“十二五”国家级规划教材、国家级一流本科课程教学实践的基础上,以CH32V307微控制器为蓝本重新撰写。书中以嵌入式硬件构件及底层软件构件设计为主线,基于嵌入式软件工程的思想,按照“通用知识—驱动构件使用方法—测试实例—构件制作过程”的脉络,逐步阐述电子系统智能化嵌入式应用的软件与硬件设计。',
                    imgUrl:require('@/assets/image/college/bookImg2.png'),
                },
            ],
        }
    },
    activated(){
    },
    mounted(){
    },
  
    methods:{
        // 创新应用大赛
        gotoInnovate(){
            window.location.href='http://www.wch.cn/RISC-V-MCU-competition/'
        },
        //嵌入式芯片与系统设计大赛
        gotoChip(){
            window.location.href='http://www.socchina.net/'
        },
        // 智能汽车大赛
        gotoCar(){
            window.location.href='https://smartcar.cdstm.cn/index'
        },
        //东南大学链接
        gotoDN(){
            window.location.href='https://www.wch.cn/news/624.html'
        },
        //鼠标划入东南大学
        enterDN(){
            console.log('划入')
            document.getElementById('DN_license').style.width='290px'
            document.getElementById('DN_license').style.height='210px'
        },
        //鼠标划出东南大学
        leaveDN(){
            console.log('划出')
            document.getElementById('DN_license').style.width='262px'
            document.getElementById('DN_license').style.height='185px'
        },
        //苏州大学链接
        gotoSZ(){
            window.location.href='http://www.wch.cn/news/552.html'
        },
        //鼠标划入苏州大学
        enterSZ(){
            console.log('划入')
            document.getElementById('SZ_license').style.width='290px'
            document.getElementById('SZ_license').style.height='210px'
        },
        //鼠标划出苏州大学
        leaveSZ(){
            console.log('划出')
            document.getElementById('SZ_license').style.width='262px'
            document.getElementById('SZ_license').style.height='185px'
        },
        //合肥工业大学链接
        gotoHF(){
            window.location.href='http://www.wch.cn/news/553.html'
        },
        //鼠标划入合肥工业大学
        enterHF(){
            console.log('划入')
            document.getElementById('HF_license').style.width='290px'
            document.getElementById('HF_license').style.height='210px'
        },
        //鼠标划出合肥工业大学
        leaveHF(){
            console.log('划出')
            document.getElementById('HF_license').style.width='262px'
            document.getElementById('HF_license').style.height='185px'
        },
        //底部会员链接
        gotoPositon1(){
            window.location.href='https://riscv.org'
        },
        gotoPositon2(){
            window.location.href='http://crva.ict.ac.cn'
        },
        gotoPositon3(){
            window.location.href='http://www.crvic.org'
        }
        

    },
}
</script>
<style scoped>
    .carousel  /deep/.el-carousel__container{
        height: 420px;
    }
  .el-carousel__item:nth-child(2n) {
     background-color: transparent;
  }
  .el-carousel__item:nth-child(2n+1) {
     background-color: transparent;
  }

  .collegePlan .title{
      margin: 0 auto;
      margin-top: 20px;
      width: 275px;
      
  }
  .collegePlan .title .text{
      font-size: 36px;
      color: #333;
      line-height: 76px;
      font-family: 'Noto Sans SC';
      font-weight: 600;
  }
  .collegePlan .title .blueLine{
     width: 80px;
     height: 6px;
     margin: 0 auto;
     margin-bottom: 20px;
     background-color: rgb(30, 169, 251); 
  }
  .collegePlan .banner{
      height: 460px;
      background: url('../../assets/image/college/banner_bg.png') no-repeat 100% 50%;
      position: relative;
      display: flex;
      /* justify-content: space-between; */
      justify-content: space-evenly;
  }
  .collegePlan .banner .bannerItem{
     width: 29%;
     height: 240px;
     margin-top: 110px;
     position: relative;
  }
  .collegePlan .banner .bannerItem img{
     width: 100%;
  }
   .collegePlan .banner .bannerItem .content{
     position: absolute;
     left: 30px;
     top: 40px;
  }
   .collegePlan .banner .bannerItem .content .theme{
       color: #fff;
       font-size: 36px;
       line-height: 44px;
       font-family: 'Noto Sans SC';
       font-weight: 700;
  }
  .collegePlan .banner .bannerItem .content .detailLink{
       color: #fff;
       margin-top: 20px;
       font-size: 20px;
       font-family: 'Noto Sans SC';
       font-weight: 400;
       cursor: pointer;
  }
  .collegePlan .banner .button{
     width: 200px;
     display: flex;
     justify-content: space-between;
     position: absolute;
     left: 80%;
     top: 80%;
  }
   .collegePlan .book{
        background: url('../../assets/image/college/book_bg.png') no-repeat;
        background-size: 100% 100%;
        /* margin-top: 50px; */
        margin-top: 2%;
    }
   .collegePlan .book .bookContent{
       width: 90%;
       margin: 0 auto;
   }
   .collegePlan .book .bookContent .bookTitle{
       font-size: 36px;
       color: #fff;
       font-family: 'Noto Sans SC';
       font-weight: 700;
       text-align: center;
       padding-top: 50px;
  }
 
  .collegePlan .book .bookContent .bookItem{
      display: flex;
      justify-content: space-between;
  }
   .collegePlan .book .bookContent .mainContent .leftText{
      width: 560px;
      margin-top: 70px;
      margin-left: 160px;
  }
   .collegePlan .book .bookContent .mainContent .leftText .leftTitle{
       font-size: 30px;
       color: #fff;
       font-family: 'Noto Sans SC';
       font-weight: 400;
       margin-bottom: 40px;
  }
  .collegePlan .book .bookContent .mainContent .leftText .leftSection{
       font-size: 20px;
       color: #999;
       font-family: 'Noto Sans SC';
       font-weight: 400;
       text-indent:38px;
       letter-spacing:2px;
  }
  
  .collegePlan .book .bookButton{
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 50%;
      left: 5%;
      width: 90%;
      cursor: pointer;
  }
   .collegePlan .labor{
     margin-top: 60px;
     position: relative;
  }
   .collegePlan .labor .laborBg{
       position: absolute;
  }
  .collegePlan .labor .laborTitle .titleText{
     margin-bottom: 20px;
     font-size: 36px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 700;
     text-align: center;
  }
   .collegePlan .labor .laborTitle .blueLine{
     width: 80px;
     height: 6px;
     margin: 0 auto;
     margin-bottom: 40px;
     background-color: rgb(30, 169, 251); 
   }
   .collegePlan .labor .laborContent{
     display: flex;
     justify-content: space-between;
     width: 85%;
     margin: 0 auto;
     padding-bottom: 80px;
   }
   .collegePlan .labor .laborContent .laborLeft p{
     font-size: 20px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 400;
   }
   .collegePlan .labor .laborContent .laborRight{
        flex: 1;
        position: relative;
        margin-left: 20px;
        background: url('~@/assets/image/college/sz_border.png') no-repeat;
        background-size: 100% 100%;
   }
    .collegePlan .labor .laborContent .laborRight .dnImg{
       position: absolute;
       left: 4%;
       top: 8%;
       cursor: pointer;
   }
   .collegePlan .labor .laborContent .laborRight .dnImg .dn_text{
     font-size: 20px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     padding-left: 36%;
   }
   .collegePlan .labor .laborContent .laborRight .szImg{
       position: absolute;
       left: 36%;
       top: 8%;
       cursor: pointer;
   }
   .collegePlan .labor .laborContent .laborRight .szImg .sz_text{
     font-size: 20px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     padding-left: 36%;
   }
    .collegePlan .labor .laborContent .laborRight .hfImg{
       position: absolute;
       left: 68%;
       top: 8%;
       cursor: pointer;
   }
   .collegePlan .labor .laborContent .laborRight .hfImg .hf_text{
     font-size: 20px;
     color: #333;
     font-family: 'Noto Sans SC';
     font-weight: 400;
     padding-left: 30%;
   }
   .collegePlan .contact{
       padding-bottom: 60px;
       width: 100%;
       margin: 0 auto;
       background: url('../../assets/image/college/contact_bg.png') no-repeat;
       background-size: 100% 100%;
   }
   .collegePlan .contact .header{
       padding-top: 60px;
       padding-left: 22%;
   }
    .collegePlan .contact .cotactWay{
        padding-top: 60px;
        margin-left: 30%;
        display: flex;
    }
    .collegePlan .contact .cotactWay .wayText{
         font-size: 36px;
         color: #333;
         font-family: 'Noto Sans SC';
         font-weight: 700;
    }
    .collegePlan .contact .cotactWay .contactEmail{
        margin-top: 20px;
        margin-left: 12%;
    }
    .collegePlan .contact .cotactWay .contactPhone{
        margin-top: 20px;
        margin-left: 8%;
    }
    .collegePlan .position{
        display: flex;
        justify-content: space-between;
        margin-left: 6%;
        margin-right: 6%;
        padding-bottom: 60px;
        margin-top: 3%;                        
    }
    .collegePlan .position .positionItem{
        display: flex;
        cursor: pointer;
    }
    .collegePlan .position .positionItem .text{
        width: 320px;
        padding-top: 10px;
        /* margin-left: 30px; */
        font-size: 18px;
        color: #333;
    }
    
    @media screen and (min-width:2200px) and (max-width:4000px){
       .collegePlan .book .bookContent{
            width: 75%;
        }  
        .collegePlan .labor .laborContent{
            width: 60%;
        } 
    }
    @media screen and (min-width:2800px) and (max-width:4000px){
        .collegePlan .book{
            margin-top: 5%;
        }
        .collegePlan .book .bookContent .bookTitle{
            padding-top: 70px;
        }
    }

    @media screen and (min-width:1280px) and (max-width:1601px){
        .collegePlan .banner .bannerItem .content .theme{
            font-size: 30px;
        }
        .collegePlan .banner .bannerItem .content .detailLink{
            font-size: 18px ;
        }
     /* .collegePlan .banner .bannerItem img{
       width: 420px;
     }
     .collegePlan .book{
        background: url('../../assets/image/college/book_bg.png') no-repeat;
        background-size: 1685px;
     }
    .collegePlan .book .bookContent{
       width: 1360px;
       margin: 0 auto;
    }
    .collegePlan .book .bookContent .mainContent .rightImg{
        width: 450px;
        height: 380px;
    }
     .collegePlan .book .bookContent .mainContent .rightImg img{
        width: 450px;
        height: 380px;
    }
     .collegePlan .labor .laborContent{
       margin-left: 300px;
       margin-right: 300px;
       padding-bottom: 80px;
    }
    .collegePlan .contact{
       width: 1360px;
       background-size: 1360px 324px;
    }
    .collegePlan .contact .cotactWay .wayText{
         font-size: 28px;
    }
    .collegePlan .contact .cotactWay .contactEmail{
        margin-top: 10px;
        margin-left: 120px;
    }
    .collegePlan .contact .cotactWay .contactPhone{
        margin-top: 10px;
        margin-left: 120px;
    } */

  }
</style>